<template>
    <div class="payment-container">
        <div class="payment-card">
            <!-- Logo区域 -->
            <div class="logo-header">
                <div class="logo">
                    <img src="../assets/Logo.png" alt="Logo" class="logo-img">
                </div>
                <h2>确认支付</h2>
            </div>

            <div class="payment-header">
                <button v-if="type !== 'lifetime'" class="back-btn" @click="goBack">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M15 18l-6-6 6-6"/>
                    </svg>
                </button>
            </div>

            <div class="order-summary">
                <div class="plan-info">
                    <h3>{{ selectedPlan.name }}</h3>
                    <div class="plan-duration">{{ selectedPlan.duration }}</div>
                </div>
                <div class="price-info">
                    <div class="final-price">¥{{ selectedPlan.price }}</div>
                    <div v-if="selectedPlan.originalPrice" class="original-price">
                        原价 ¥{{ selectedPlan.originalPrice }}
                    </div>
                    <div v-if="type === 'lifetime'" class="price-tip">
                        微信渠道特惠
                    </div>
                </div>
            </div>

            <!-- 优惠码区域 -->
            <div v-if="type === 'lifetime'" class="coupon-section-wrapper">
                <div class="coupon-input-group">
                    <input 
                        v-model="couponCode" 
                        type="text" 
                        placeholder="请输入优惠码（可空）" 
                        class="coupon-input"
                        :disabled="isCouponValid"
                    >
                    <button @click="checkCoupon" class="coupon-btn" :disabled="!couponCode || isCouponValid">
                        {{ isCouponValid ? '已使用' : '兑换' }}
                    </button>
                </div>
                
                <div v-if="isCouponValid" class="discount-card">
                    <div class="discount-header">
                        <div class="discount-title-group">
                            <span class="discount-icon">🎉</span>
                            <span class="discount-title">优惠已生效</span>
                        </div>
                        <span class="discount-val">- ¥{{ discountAmount }}</span>
                    </div>
                    <div class="discount-desc">
                        VIP专属优惠
                    </div>
                </div>

                <div v-if="couponMessage" class="coupon-message" :class="{ 'error': !isCouponValid, 'success': isCouponValid }">
                    {{ couponMessage }}
                </div>
            </div>

            <div class="payment-form">
                <div class="form-group">
                    <label for="unionId">UnionID</label>
                    <input type="text" id="unionId" v-model="unionId" placeholder="请输入您的UnionID"
                        :class="{ 'error': unionIdError }" />
                    <div v-if="unionIdError" class="error-message">{{ unionIdError }}</div>
                    <div v-if="mismatchWarning && !unionIdError" class="mismatch-warning">
                        ⚠️ {{ mismatchWarning }}
                    </div>
                    <div v-if="isAutoFilled && !unionIdError && !mismatchWarning" class="auto-fill-tip">
                        {{ autoFillMessage }}
                    </div>

                    <div class="help-section">
                        <div class="help-title">💡 如何获取UnionID</div>
                        <div class="help-steps">
                            <div class="step">1. 打开悦览应用</div>
                            <div class="step">2. 进入「设置」→「账号管理」</div>
                            <div class="step">3. 点击头像复制 UnionID</div>
                            <div class="step">4. 请确保 UnionID 正确，否则无法到账</div>
                        </div>
                    </div>
                </div>

                <div class="payment-method">
                    <div class="method-header">
                        <span>支付方式</span>
                    </div>
                    <div class="method-option selected">
                        <div class="method-icon-wrapper">
                            <svg class="wechat-svg" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M683.058 364.695c11 0 22 1.016 32.943 1.976C686.564 230.064 538.896 128 370.681 128c-188.104 0.66-342.237 127.793-342.237 289.226 0 93.068 51.379 169.827 136.725 229.256L130.72 748.43l119.796-59.368c42.918 8.395 77.37 16.79 119.742 16.79 11 0 21.46-0.48 31.914-1.442a259.168 259.168 0 0 1-10.455-71.358c0.485-148.002 128.744-268.297 291.403-268.297l-0.06-0.06z m-184.113-91.992c25.99 0 42.913 16.79 42.913 42.575 0 25.188-16.923 42.579-42.913 42.579-25.45 0-51.38-16.85-51.38-42.58 0-25.784 25.93-42.574 51.38-42.574z m-239.544 85.154c-25.384 0-51.374-16.85-51.374-42.58 0-25.784 25.99-42.574 51.374-42.574 25.45 0 42.918 16.79 42.918 42.575 0 25.188-16.924 42.579-42.918 42.579z m736.155 271.655c0-135.647-136.725-246.527-290.983-246.527-162.655 0-290.918 110.88-290.918 246.527 0 136.128 128.263 246.587 290.918 246.587 33.972 0 68.423-8.395 102.818-16.85l93.809 50.973-25.93-84.677c68.907-51.93 120.286-119.815 120.286-196.033z m-385.275-42.58c-16.923 0-34.452-16.79-34.452-34.179 0-16.79 17.529-34.18 34.452-34.18 25.99 0 42.918 16.85 42.918 34.18 0 17.39-16.928 34.18-42.918 34.18z m188.165 0c-16.984 0-33.972-16.79-33.972-34.179 0-16.79 16.927-34.18 33.972-34.18 25.93 0 42.913 16.85 42.913 34.18 0 17.39-16.983 34.18-42.913 34.18z" fill="#09BB07"></path>
                            </svg>
                        </div>
                        <span class="method-name">微信支付</span>
                        <div class="check-icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <!-- 用户协议勾选 -->
                <div class="agreement-section">
                    <label class="agreement-checkbox">
                        <input type="checkbox" v-model="agreeToTerms" :class="{ 'error': agreementError }">
                        <span class="checkmark"></span>
                        <span class="agreement-text">
                            我已阅读并同意
                            <a href="http://yuelan.charactech.cn/useragreement/pro" target="_blank" rel="noopener">《悦览PRO用户服务协议》</a>
                        </span>
                    </label>
                    <div v-if="agreementError" class="error-message">{{ agreementError }}</div>
                </div>

                <button class="pay-btn" @click="showPaymentModal" :disabled="loading || !unionId || !agreeToTerms">
                    <div v-if="loading" class="loading-spinner"></div>
                    {{ loading ? '处理中...' : `微信支付 ¥${selectedPlan.price}` }}
                </button>
            </div>

            <!-- 版权信息 -->
            <div class="footer-copyright">
                <p>© 2025 珠海字符科技有限公司 版权所有</p>
                <p><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">粤ICP备2025361041号</a></p>
            </div>
        </div>

        <!-- 优化后的付款前提示弹窗 -->
        <div v-if="showModal" class="modal-overlay" @click="closeModal">
            <div class="modal-container">
                <div class="modal-content" @click.stop>
                    <div class="modal-icon">
                        <div class="icon-circle">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#3B82F6"/>
                            </svg>
                        </div>
                    </div>
                    
                    <div class="modal-body">
                        <h3 class="modal-title">支付提示</h3>
                        <p class="modal-message">付款完成返回后可能需要2秒左右弹出购买结果，请静候</p>
                    </div>
                    
                    <div class="modal-actions">
                        <button class="btn-secondary" @click="closeModal">取消</button>
                        <button class="btn-primary" @click="confirmPayment">确认支付</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 重新设计的微信支付二维码弹窗 -->
        <div v-if="showWechatQR" class="modal-overlay" @click="closeWechatQR">
            <div class="modal-container">
                <div class="modal-content" @click.stop>
                    <!-- 弹窗图标 -->
                    <div class="modal-icon">
                        <div class="icon-circle wechat-icon">
                            <svg width="32" height="32" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M683.058 364.695c11 0 22 1.016 32.943 1.976C686.564 230.064 538.896 128 370.681 128c-188.104 0.66-342.237 127.793-342.237 289.226 0 93.068 51.379 169.827 136.725 229.256L130.72 748.43l119.796-59.368c42.918 8.395 77.37 16.79 119.742 16.79 11 0 21.46-0.48 31.914-1.442a259.168 259.168 0 0 1-10.455-71.358c0.485-148.002 128.744-268.297 291.403-268.297l-0.06-0.06z m-184.113-91.992c25.99 0 42.913 16.79 42.913 42.575 0 25.188-16.923 42.579-42.913 42.579-25.45 0-51.38-16.85-51.38-42.58 0-25.784 25.93-42.574 51.38-42.574z m-239.544 85.154c-25.384 0-51.374-16.85-51.374-42.58 0-25.784 25.99-42.574 51.374-42.574 25.45 0 42.918 16.79 42.918 42.575 0 25.188-16.924 42.579-42.918 42.579z m736.155 271.655c0-135.647-136.725-246.527-290.983-246.527-162.655 0-290.918 110.88-290.918 246.527 0 136.128 128.263 246.587 290.918 246.587 33.972 0 68.423-8.395 102.818-16.85l93.809 50.973-25.93-84.677c68.907-51.93 120.286-119.815 120.286-196.033z m-385.275-42.58c-16.923 0-34.452-16.79-34.452-34.179 0-16.79 17.529-34.18 34.452-34.18 25.99 0 42.918 16.85 42.918 34.18 0 17.39-16.928 34.18-42.918 34.18z m188.165 0c-16.984 0-33.972-16.79-33.972-34.179 0-16.79 16.927-34.18 33.972-34.18 25.93 0 42.913 16.85 42.913 34.18 0 17.39-16.983 34.18-42.913 34.18z" fill="#09BB07"></path>
                            </svg>
                        </div>
                    </div>
                    
                    <!-- 弹窗内容 -->
                    <div class="modal-body">
                        <h3 class="modal-title">微信扫码支付</h3>
                        
                        <!-- 订单信息 -->
                        <div class="order-summary-modal">
                            <div class="order-item">
                                <span class="order-label">商品</span>
                                <span class="order-value">{{ selectedPlan.name }}</span>
                            </div>
                            <div class="order-item">
                                <span class="order-label">金额</span>
                                <span class="order-value price">¥{{ selectedPlan.price }}</span>
                            </div>
                        </div>
                        
                        <!-- 二维码区域 -->
                        <div class="qr-section">
                            <div class="qr-container">
                                <!-- 错误状态覆盖层 -->
                                <div v-if="qrCodeError" class="qr-error-overlay">
                                    <div class="error-icon">⚠️</div>
                                    <p class="error-text">二维码生成失败</p>
                                    <button class="retry-button" @click="regenerateQRCode">重新生成</button>
                                </div>
                                
                                <!-- 加载状态覆盖层 -->
                                <div v-if="qrGenerating" class="qr-loading-overlay">
                                    <div class="loading-spinner"></div>
                                    <p class="loading-text">生成中...</p>
                                </div>
                                
                                <!-- Canvas始终存在 -->
                                <div class="qr-code-wrapper">
                                    <canvas 
                                        ref="qrCanvas" 
                                        class="qr-code-display"
                                        width="200" 
                                        height="200"
                                        :style="{opacity: (qrCodeError || qrGenerating) ? 0 : 1}"
                                    ></canvas>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 扫码提示 -->
                        <div class="scan-instructions">
                            <p class="instruction-text">请使用微信扫描上方二维码完成支付</p>
                        </div>
                    </div>
                    
                    <!-- 弹窗操作按钮 -->
                    <div class="modal-actions">
                        <button class="btn-secondary" @click="closeWechatQR">取消支付</button>
                        <button class="btn-primary" @click="goToStatusCheck">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="margin-right: 6px;">
                                <path d="M13.5 4.5L6 12l-3.5-3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            已完成支付
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
    name: 'PaymentView',
    props: ['type'],
    data() {
        return {
            unionId: '',
            unionIdError: '',
            couponCode: '',
            couponMessage: '',
            discountAmount: 0,
            isCouponValid: false,
            agreeToTerms: false,
            agreementError: '',
            loading: false,
            isAutoFilled: false,
            autoFillMessage: '',
            originalUnionId: '',
            mismatchWarning: '',
            showModal: false,
            showWechatQR: false,
            qrCodeError: false,
            qrGenerating: false,
            wechatPayUrl: '',
            membershipPlans: {
                monthly: { name: '月度悦览PRO', price: 6, subject: '月度悦览PRO', duration: '1个月' },
                halfyear: { name: '半年悦览PRO', price: 30, subject: '半年悦览PRO', duration: '6个月' },
                yearly: { name: '年度悦览PRO', price: 58, subject: '年度悦览PRO', duration: '12个月', originalPrice: 88 },
                lifetime: { name: '永久悦览PRO', price: 82, subject: '永久悦览PRO', duration: '永久有效', originalPrice: 88 }
            }
        }
    },
    computed: {
        selectedPlan() {
            return this.membershipPlans[this.type] || this.membershipPlans.monthly
        }
    },
    watch: {
        unionId() {
            if (this.unionIdError) {
                this.unionIdError = ''
            }
            
            // 检查是否与URL参数中的原始UnionID不一致
            if (this.originalUnionId && this.unionId.trim() !== this.originalUnionId) {
                this.mismatchWarning = '您输入的UnionID与您悦览所登录账号的不符，请确认'
            } else {
                this.mismatchWarning = ''
            }

            // 当用户输入unionID时，保存到localStorage
            if (this.unionId.trim()) {
                localStorage.setItem('unionId', this.unionId.trim())
            }
        },
        agreeToTerms() {
            if (this.agreementError) {
                this.agreementError = ''
            }
        }
    },
    mounted() {
        const unionIDFromQuery = this.$route.query.unionID
        const urlParams = new URLSearchParams(window.location.search)
        const unionIDFromUrl = urlParams.get('unionID')
        const storedUnionId = localStorage.getItem('unionId')

        if (unionIDFromQuery || unionIDFromUrl) {
            const urlUnionId = unionIDFromQuery || unionIDFromUrl
            this.unionId = urlUnionId
            this.originalUnionId = urlUnionId
            this.isAutoFilled = true
            this.autoFillMessage = '✨ 已自动填充登录账号的 UnionID'
        } else if (storedUnionId) {
            this.unionId = storedUnionId
            this.isAutoFilled = true
            this.autoFillMessage = '✨ 已自动填写上次使用的 UnionID'
        }
    },
    methods: {
        async checkCoupon() {
            if (!this.couponCode) return;
            
            try {
                const response = await fetch('https://api.charactech.cn/yuelan/v2/coupon/check', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ code: this.couponCode })
                });
                
                const result = await response.json();
                
                if (result.code === 200 && result.data && result.data.valid) {
                    if (result.data.type === 'vip-10') {
                        // 直接修改当前选中的套餐价格
                        if (this.type === 'lifetime') {
                            this.membershipPlans.lifetime.price = 72;
                            this.discountAmount = 10;
                            this.isCouponValid = true;
                            this.couponMessage = '';
                        }
                    } else if (result.data.type === 'vip-20') {
                        // vip-20 减免20元
                        if (this.type === 'lifetime') {
                            this.membershipPlans.lifetime.price = 62;
                            this.discountAmount = 20;
                            this.isCouponValid = true;
                            this.couponMessage = '';
                        }
                    } else {
                        this.couponMessage = '优惠码有效，但该优惠码不适用于此商品';
                        this.isCouponValid = false;
                    }
                } else {
                    this.couponMessage = result.msg || '优惠码无效';
                    this.isCouponValid = false;
                }
            } catch (error) {
                console.error('Coupon check error:', error);
                this.couponMessage = '校验失败，请稍后重试';
                this.isCouponValid = false;
            }
        },

        goBack() {
            this.$router.go(-1)
        },

        validateUnionId() {
            if (!this.unionId.trim()) {
                this.unionIdError = '请输入UnionID'
                return false
            }
            if (this.unionId.length < 10) {
                this.unionIdError = 'UnionID格式不正确'
                return false
            }
            return true
        },

        validateAgreement() {
            if (!this.agreeToTerms) {
                this.agreementError = '请先同意用户服务协议'
                return false
            }
            return true
        },

        showPaymentModal() {
            if (!this.validateUnionId() || !this.validateAgreement()) {
                return
            }
            this.showModal = true
        },

        closeModal() {
            this.showModal = false
        },

        isWechatBrowser() {
            const ua = navigator.userAgent.toLowerCase()
            return ua.includes('micromessenger')
        },

        generateWechatPayUrl() {
            const baseUrl = 'https://pay.charactech.cn/'
            const params = {
                tp: 'order',
                cb: 'http://self-api:5001/buy',
                dt: JSON.stringify({ unionID: this.unionId.trim(), cp: this.couponCode || '' }),
                amount: this.selectedPlan.price,
                description: this.selectedPlan.name
            }
            
            const urlParams = new URLSearchParams()
            Object.keys(params).forEach(key => {
                urlParams.append(key, params[key])
            })
            
            return baseUrl + '?' + urlParams.toString()
        },

        async confirmPayment() {
            this.showModal = false
            await this.handleWechatPayment()
        },

        async generateQRCode(text) {
            console.log('Starting QR code generation for:', text)
            this.qrCodeError = false
            this.qrGenerating = true
            
            try {
                // 确保DOM更新
                await this.$nextTick()
                
                // 直接检查canvas是否存在
                const canvas = this.$refs.qrCanvas
                if (!canvas) {
                    console.error('Canvas ref not found in $refs:', Object.keys(this.$refs))
                    throw new Error('Canvas reference not found')
                }
                
                console.log('Canvas found, generating QR code...')
                
                // 清空canvas
                const ctx = canvas.getContext('2d')
                ctx.clearRect(0, 0, 200, 200)
                
                // 生成二维码
                await QRCode.toCanvas(canvas, text, {
                    width: 200,
                    height: 200,
                    color: {
                        dark: '#000000',
                        light: '#ffffff'
                    },
                    errorCorrectionLevel: 'M',
                    margin: 1
                })
                
                console.log('QR Code generated successfully')
                this.qrGenerating = false
                
            } catch (error) {
                console.error('QR Code generation failed:', error)
                this.qrCodeError = true
                this.qrGenerating = false
            }
        },

        async regenerateQRCode() {
            console.log('Regenerating QR code...')
            if (this.wechatPayUrl) {
                await this.generateQRCode(this.wechatPayUrl)
            } else {
                console.error('No WeChat pay URL available')
                this.qrCodeError = true
                this.qrGenerating = false
            }
        },

        async handleWechatPayment() {
            localStorage.setItem('unionId', this.unionId.trim())
            
            this.wechatPayUrl = this.generateWechatPayUrl()
            console.log('Generated WeChat pay URL:', this.wechatPayUrl)
            
            if (this.isWechatBrowser()) {
                window.location.href = this.wechatPayUrl
            } else {
                // 先显示弹窗
                this.showWechatQR = true
                
                // 等待弹窗渲染完成
                await this.$nextTick()
                await new Promise(resolve => setTimeout(resolve, 100))
                
                // 生成二维码
                await this.generateQRCode(this.wechatPayUrl)
            }
        },

        closeWechatQR() {
            this.showWechatQR = false
            this.qrCodeError = false
            this.qrGenerating = false
            this.wechatPayUrl = ''
        },

        goToStatusCheck() {
            this.$router.push('/vip-status')
        }
    }
}
</script>

<style scoped>
.payment-container {
    min-height: 100vh;
    background: #f1f5f9;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.payment-card {
    background: white;
    border-radius: 20px;
    padding: 32px;
    max-width: 440px;
    width: 100%;
    box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.8);
    position: relative;
    overflow: hidden;
}

.logo-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
}

.logo-img {
    width: 80px;
    height: auto;
    margin-bottom: 12px;
}

.logo-header h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
}

.payment-header {
    position: absolute;
    left: 20px;
    top: 20px;
}

.back-btn {
    background: white;
    border: 1px solid #e2e8f0;
    color: #64748b;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 10px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.back-btn:hover {
    background: #f8fafc;
    color: #3b82f6;
    border-color: #cbd5e1;
}

.order-summary {
    background: linear-gradient(145deg, #f8fafc, #f1f5f9);
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e2e8f0;
}

.plan-info h3 {
    margin: 0 0 6px 0;
    font-size: 1.1rem;
    font-weight: 700;
    color: #1e293b;
}

.plan-duration {
    color: #64748b;
    font-size: 0.85rem;
    font-weight: 500;
}

.price-info {
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.final-price {
    font-size: 1.5rem;
    font-weight: 800;
    color: #3b82f6;
    line-height: 1;
    margin-bottom: 4px;
}

.original-price {
    font-size: 0.75rem;
    color: #94a3b8;
    text-decoration: line-through;
    margin-bottom: 2px;
}

.price-tip {
    font-size: 0.7rem;
    color: #ef4444;
    font-weight: 600;
    background: #fef2f2;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid #fee2e2;
    white-space: nowrap;
}

.payment-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #334155;
    font-size: 0.9rem;
}

.form-group input {
    width: 100%;
    padding: 14px 16px;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    font-size: 1rem;
    transition: all 0.2s ease;
    box-sizing: border-box;
    color: #1e293b;
    background: #f8fafc;
}

.form-group input:focus {
    outline: none;
    border-color: #3b82f6;
    background: white;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.form-group input.error {
    border-color: #ef4444;
    background: #fef2f2;
}

.error-message {
    color: #ef4444;
    font-size: 0.8rem;
    margin-top: 6px;
    display: flex;
    align-items: center;
}

.auto-fill-tip {
    color: #059669;
    font-size: 0.8rem;
    margin-top: 6px;
    display: flex;
    align-items: center;
    animation: fadeIn 0.3s ease;
}

.mismatch-warning {
    color: #d97706;
    font-size: 0.8rem;
    margin-top: 6px;
    display: flex;
    align-items: center;
    animation: fadeIn 0.3s ease;
}

.help-section {
    margin-top: 12px;
    padding: 14px;
    background: #f0f9ff;
    border-radius: 12px;
    border: 1px solid #bae6fd;
}

.help-title {
    font-weight: 700;
    color: #0284c7;
    margin-bottom: 8px;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    gap: 6px;
}

.help-steps {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.step {
    color: #334155;
    font-size: 0.8rem;
    line-height: 1.4;
}

.method-header {
    margin-bottom: 10px;
    font-weight: 600;
    color: #334155;
    font-size: 0.9rem;
}

.method-option {
    display: flex;
    align-items: center;
    padding: 16px;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    cursor: default;
    transition: all 0.2s ease;
    background: white;
}

.method-option.selected {
    border-color: #3b82f6;
    background: #f0f9ff;
    position: relative;
}

.method-icon-wrapper {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
}

.wechat-svg {
    width: 100%;
    height: 100%;
}

.method-name {
    flex: 1;
    font-weight: 600;
    color: #1e293b;
    font-size: 1rem;
}

.check-icon {
    color: #3b82f6;
    display: flex;
    align-items: center;
    justify-content: center;
}

.agreement-section {
    margin-top: 4px;
}

.agreement-checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    font-size: 0.85rem;
    line-height: 1.5;
    position: relative;
    padding-left: 28px;
}

.agreement-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    position: absolute;
    top: 2px;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: white;
    border: 2px solid #cbd5e1;
    border-radius: 4px;
    transition: all 0.2s;
}

.agreement-checkbox:hover input ~ .checkmark {
    border-color: #3b82f6;
}

.agreement-checkbox input:checked ~ .checkmark {
    background-color: #3b82f6;
    border-color: #3b82f6;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.agreement-checkbox input:checked ~ .checkmark:after {
    display: block;
}

.agreement-checkbox .checkmark:after {
    left: 5px;
    top: 1px;
    width: 4px;
    height: 9px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.agreement-text {
    color: #64748b;
}

.agreement-text a {
    color: #3b82f6;
    text-decoration: none;
    font-weight: 500;
}

.agreement-text a:hover {
    text-decoration: underline;
}

.pay-btn {
    width: 100%;
    background: #3b82f6;
    color: white;
    border: none;
    padding: 16px;
    border-radius: 12px;
    font-size: 1.05rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.pay-btn:hover:not(:disabled) {
    background: #2563eb;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.pay-btn:active:not(:disabled) {
    transform: translateY(0);
}

.pay-btn:disabled {
    background: #cbd5e1;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
}

.loading-spinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.footer-copyright {
    text-align: center;
    padding-top: 24px;
    margin-top: 8px;
    border-top: 1px solid #f1f5f9;
    color: #94a3b8;
    font-size: 0.75rem;
    line-height: 1.6;
}

.footer-copyright a {
    color: #94a3b8;
    text-decoration: none;
    transition: color 0.2s;
}

.footer-copyright a:hover {
    color: #64748b;
}

/* Coupon Styles */
.coupon-section-wrapper {
    margin-bottom: 24px;
    background: #f8fafc;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
}

.coupon-input-group {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}

.coupon-input {
    flex: 1;
    padding: 10px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.9rem;
    outline: none;
    transition: border-color 0.2s;
    background: white;
}

.coupon-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.coupon-input:disabled {
    background-color: #f1f5f9;
    color: #94a3b8;
}

.coupon-btn {
    padding: 8px 16px;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
    font-weight: 500;
}

.coupon-btn:hover:not(:disabled) {
    background: #2563eb;
}

.coupon-btn:disabled {
    background: #cbd5e1;
    cursor: not-allowed;
}

.coupon-message {
    font-size: 0.8rem;
    text-align: left;
    margin-top: 6px;
}

.coupon-message.error { color: #ef4444; }
.coupon-message.success { color: #10b981; }

.discount-card {
    background: linear-gradient(135deg, #fff1f2 0%, #fff 100%);
    border: 1px solid #fecdd3;
    border-radius: 10px;
    padding: 12px 16px;
    margin-top: 12px;
    animation: fadeIn 0.3s ease;
}

.discount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.discount-title-group {
    display: flex;
    align-items: center;
    gap: 6px;
}

.discount-title {
    color: #be123c;
    font-weight: 600;
    font-size: 0.95rem;
}

.discount-val {
    color: #be123c;
    font-weight: 700;
    font-size: 1.1rem;
}

.discount-desc {
    color: #e11d48;
    font-size: 0.8rem;
    opacity: 0.9;
    margin-left: 28px;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.modal-container {
    width: 100%;
    max-width: 360px;
    perspective: 1000px;
}

.modal-content {
    background: white;
    border-radius: 24px;
    padding: 32px 24px;
    width: 100%;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    text-align: center;
    animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(20px) scale(0.95); }
    to { opacity: 1; transform: translateY(0) scale(1); }
}

.modal-icon {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
}

.icon-circle {
    width: 60px;
    height: 60px;
    background: #eff6ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3b82f6;
}

.wechat-icon {
    background: #dcfce7;
    color: #07C160;
}

.modal-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 10px 0;
}

.modal-message {
    font-size: 0.95rem;
    color: #64748b;
    line-height: 1.6;
    margin: 0 0 24px 0;
}

.modal-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.btn-primary, .btn-secondary {
    padding: 14px;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-primary {
    background: #3b82f6;
    color: white;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.btn-primary:hover {
    background: #2563eb;
    transform: translateY(-1px);
}

.btn-secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
}

.btn-secondary:hover {
    background: #f8fafc;
    color: #475569;
    border-color: #cbd5e1;
}

/* Order Summary in Modal */
.order-summary-modal {
    background: #f8fafc;
    border-radius: 12px;
    padding: 16px;
    margin: 0 0 24px 0;
    border: 1px solid #e2e8f0;
}

.order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.order-item:last-child {
    margin-bottom: 0;
    padding-top: 8px;
    border-top: 1px dashed #cbd5e1;
}

.order-label {
    color: #64748b;
    font-size: 0.9rem;
}

.order-value {
    font-weight: 600;
    color: #1e293b;
}

.order-value.price {
    color: #3b82f6;
    font-size: 1.1rem;
}

/* QR Code Section */
.qr-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
}

.qr-container {
    position: relative;
    width: 180px;
    height: 180px;
    padding: 10px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
}

.qr-code-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qr-code-display {
    width: 100% !important;
    height: 100% !important;
}

.qr-loading-overlay, .qr-error-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255,255,255,0.9);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
    border-radius: 12px;
}

.scan-instructions {
    margin-bottom: 24px;
}

.instruction-text {
    font-size: 0.85rem;
    color: #64748b;
    margin: 0;
}

.retry-button {
    background: #ef4444;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 0.8rem;
    cursor: pointer;
    margin-top: 8px;
}

/* Mobile Optimization */
@media (max-width: 640px) {
    .payment-container {
        padding: 0;
        background: white;
        align-items: flex-start;
    }
    
    .payment-card {
        box-shadow: none;
        border: none;
        border-radius: 0;
        padding: 24px 20px 40px;
        max-width: 100%;
    }
    
    .payment-header {
        top: 16px;
        left: 16px;
    }

    .back-btn {
        border: none;
        background: #f1f5f9;
    }

    .modal-overlay {
        align-items: flex-end;
        padding: 0;
        background: rgba(0, 0, 0, 0.5);
    }
    
    .modal-container {
        max-width: 100%;
    }
    
    .modal-content {
        border-radius: 24px 24px 0 0;
        padding: 32px 24px 32px;
    }
    
    .logo-header {
        margin-top: 10px;
    }
}
</style>